import * as React from "react";
import * as Sentry from "@sentry/react";
import App from "./App";

function isACredential(storageKey) {
    return storageKey.toLowerCase().includes('token');
}

export default function MonitoredApp({appName}) {
    function handleError(event) {
        try {
            const localStorageData = {};
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                try {
                    localStorageData[key] = isACredential(key) ? '[redacted]' : localStorage.getItem(key);
                } catch (readingError) {
                    localStorageData[key] = '[Error reading value]';
                }
            }

            event.contexts = event.contexts || {};
            event.contexts.localStorage = localStorageData;
            event.contexts.session = {
                userAgent: navigator.userAgent,
                language: navigator.language,
                screenSize: `${window.innerWidth}x${window.innerHeight}`,
                url: window.location.href,
                timestamp: new Date().toISOString()
            };
        } catch (error) {
            console.error("Error in context capture for Sentry:", error);
        }
        return event;
    }
    let environment = process.env.REACT_APP_ENVIRONMENT;
    if (environment === 'production') {
        Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            sampleRate: 1.0,
            environment: appName,
            beforeSend(event) {
                return handleError(event);
            },
        });
        return <Sentry.ErrorBoundary
                fallback={
                    <div className="error-container">
                        <h2>Ha ocurrido un error inesperado</h2>
                        <p>Por favor, intenta recargar la página</p>
                    </div>                }
            >
                <App />
            </Sentry.ErrorBoundary>
    } else {
        return <App/>
    }
}
